import React from "react";
import PropTypes from "prop-types";

function BothSideLineTitle({ text }) {
  return (
    <small id="both-side-line-title">
      <span className="text-muted">{text}</span>
    </small>
  );
}

BothSideLineTitle.propTypes = {
  text: PropTypes.string.isRequired,
};

export default BothSideLineTitle;
